function initializeFixedBundleDescriptions(root) {
  if (root.dataset.initialized === 'true') return;
  const track = root.querySelector('[data-uep-description-track]');
  const previous = root.querySelector('[data-uep-description-prev]');
  const next = root.querySelector('[data-uep-description-next]');
  if (!track || !previous || !next) return;
  root.dataset.initialized = 'true';
  previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
  const update = () => {
    const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
    const overflow = max > 0;
    previous.hidden = !overflow;
    next.hidden = !overflow;
    previous.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= max;
  };
  track.addEventListener('scroll', update, { passive: true });
  const observer = new ResizeObserver(update);
  observer.observe(track);
  requestAnimationFrame(update);
}
function initializeAllFixedBundleDescriptions(root = document) {
  root.querySelectorAll('[data-uep-fixed-bundle-descriptions]').forEach(initializeFixedBundleDescriptions);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeAllFixedBundleDescriptions(), { once: true });
} else {
  initializeAllFixedBundleDescriptions();
}
document.addEventListener('shopify:section:load', event => initializeAllFixedBundleDescriptions(event.target));
